<template>
    <div class="autocomplete">
        <div class="search__wrapper">
            <input
                    id="device-search"
                    type="text"
                    class="search"
                    placeholder="Search for devices"
                    @input="onChange"
                    v-model="search"
                    @keyup.down="onArrowDown"
                    @keyup.up="onArrowUp"
                    @keyup.enter="onEnter"
            />
            <label for="device-search"></label>
        </div>
        <div class="autocomplete-results__wrapper" style="background:red">
            <ul
                    v-bar
                    id="autocomplete-results"
                    v-show="isOpen"
                    class="autocomplete-results"
            >
                <div>
                    <li
                            class="loading"
                            v-if="isLoading"
                    >
                        Loading results...
                    </li>
                    <li
                            v-else
                            v-for="(result, i) in results"
                            :key="i"
                            @click="setResult(result)"
                            class="autocomplete-result"
                            :class="{ 'is-active': i === arrowCounter }"
                    >
                        {{ result.name }}
                    </li>
                </div>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'autocomplete',

        props: {
            items: {
                type: Array,
                required: false,
                default: () => [],
            },
            isAsync: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                arrowCounter: 0,
                isLoading: false,
                isOpen: false,
                results: [],
                search: ''
            };
        },

        methods: {
            onChange() {
                // Is the data given by an outside ajax request?
                if (this.isAsync) {
                    this.isLoading = true;
                } else {
                    // Let's  our flat array
                    this.filterResults();
                    this.isOpen = true;
                }
            },

            filterResults() {
                // first uncapitalize all the things
                this.results = this.items.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                });
            },
            setResult(result) {
                this.search = result.name;
                this.$emit('deviceSelected', result);
                this.isOpen = false;
            },
            onArrowDown(evt) {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                }
            },
            onEnter() {
                this.$emit('deviceSelected', this.results[this.arrowCounter]);
                this.search = this.results[this.arrowCounter].name;
                this.isOpen = false;
                this.arrowCounter = -1;
            },
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    this.isOpen = false;
                    this.arrowCounter = -1;
                }
            }
        },
        watch: {
            items: function (val, oldValue) {
                // actually compare them
                if (val.length !== oldValue.length) {
                    this.results = val;
                    this.isLoading = false;
                }
            },
        },
        created() {
            this.eventHub.$on('resetAutocomplete', data => {
                this.search = '';
            });
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside)
        },
        destroyed() {
            document.removeEventListener('click', this.handleClickOutside)
        }
    };
</script>

<style lang="scss" scoped>
    .autocomplete {
        position: relative;

        @media(min-width: 1024px) {
            margin-right: 22px;
            width: calc(50% - 11px);
        }

        &-results__wrapper {
            position: absolute;
            width: 100%;
            z-index: 1000;
        }
    }

    .autocomplete-results {
        margin: 0;
        border: 1px solid #eeeeee;
        background: #000;
        border-radius: 5px;
        height: 120px;
        overflow: auto;
        opacity: 1;
        padding: 8px 5px 8px;
        width: 100%;

        .vb-dragger {
            right: 5px;
        }
    }

    .autocomplete-result {
        background: #000;
        border-radius: 5px;
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    }

    .autocomplete-result:hover {
        background-color: rgba(255, 255, 255, 0.5);
        color: white;
    }

    .search__wrapper {
        position: relative;

        label {
            background: transparent url('../../assets/search.svg');
            height: 14px;
            position: absolute;
            width: 14px;
            opacity: .5;
            top: 12px;
            right: 12px;
        }

        &:hover {
            label {
                opacity: 1;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/helpers/AutoComplete.vue